angular.module('picmonic-common').factory('PendoService', [
  '$cookies',
  function ($cookies) {
    return {
      setUserInfo: function (user) {
        if (window.pendo && window.pls_config.app_env === 'production') {
          if (user.user_id) {
            window.pendo.initialize({
              visitor: {
                id: user.user_id,
                email: user.email,
                first_name: user.first_name,
                last_name: user.last_name,
                full_name: user.first_name + '' + user.last_name,
                role: user.role,
                lead: user.lead,
                cards_mastered: user.cards_mastered,
                grad_year: user.graduation_year ? user.graduation_year : '',
                subscription_type: user.subscription_type,
                subscription_expiration: user.expiration,
                created_at: user.created_at,
                school_name: user.school ? user.school.name : '',
                preso_wanted: user.school && user.school.preso_wanted ? 1 : 0,
                referral_purchases: user.referral_purchases,
                referral_signups: user.referral_signups,
                referral_code: user.referrer_code,
                mobile_app_downloaded: user.mobile_app_downloaded ? 'yes' : 'no',
                cards_viewed: user.cards_viewed,
                spaced_rep_interaction: user.spaced_rep_date ? 'yes' : 'no',
                playlist_created: user.playlist_created ? 'yes' : 'no',
                market_name: user.market && user.market.name ? user.market.name : '',
                medical_terminology_expiration_date: user.medical_terminology_expiration_date,
                on_premium_trial: user.on_premium_trial ? 'yes' : 'no',
                approved_educator: user.approved_educator ? 'yes' : 'no',
                student_officer: user.student_officer,
                subscription_cancelled: user.subscription_cancelled ? 'yes' : 'no',
                is_referred: user.is_referred ? 'yes' : 'no',
                ugc_creator: user.ugc_license ? 'yes' : 'no',
                register_source: user.register_source ? user.register_source : '',
                referrer_name: user?.referrer?.name,
                institutional_sub: user.institutional_sub,
              },
            });
          } else {
            // Only use if we want to track anonymous users
            /*
            window.pendo.initialize({
              visitor: {
              },
            });
            */
          }
        } else if (window.pendo && window.pls_config.app_env !== 'production') {
          window.pendo.initialize({
            disableGuides: $cookies.get('pls_disable_pendo') === 'true',
          });
        }
      },
    };
  },
]);
